import { G, Path } from '@react-pdf/renderer';
import React from 'react';

import { SVGPoiData } from '../../../../../../utils/three/vectorize-geometry';

type PoiMarkerProps = {
  poi: SVGPoiData;
  preview: boolean;
};

const locationDotNaturalWidth = 384;
const locationDotNaturalHeight = 512;

/**
 * Calculates the dimensions for -50%, -100% of the icon.
 */
function calculateIconOffset(scale: number) {
  return {
    offsetX: -(locationDotNaturalWidth * scale) * 0.5,
    offsetY: -locationDotNaturalHeight * scale * 1.0,
  };
}

const scale = 0.038;
const { offsetX, offsetY } = calculateIconOffset(scale);
// FontAwesome locationDot icon as SVG path for React-pdf compatibility
const locationDotD =
  'M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z';
// Numbers manually adjusted according to the svgs default size.
const transform = `translate(${offsetX}, ${offsetY}) scale(${scale})`;
const color = '#ffdd33';

/**
 * POI Marker component that displays a POI marker
 * Used in CAD drawing reports to indicate POI locations
 */
export const PoiMarker: React.FC<PoiMarkerProps> = ({ poi, preview }) => {
  const position = `translate(${poi.x}, ${poi.y})`;

  if (preview) {
    return (
      <g transform={position}>
        <g>
          <path d={locationDotD} fill={color} transform={transform} />
        </g>
      </g>
    );
  }

  return (
    <G transform={position}>
      <G>
        <Path d={locationDotD} fill={color} transform={transform} />
      </G>
    </G>
  );
};
